import Footer from 'components/footer';
import styled, { ThemeProvider } from 'styled-components';
import { lightTheme } from 'styles/new-theme';
import { fontM, fontL } from 'styles/jakarta';
import SVG from 'assets/svgs';
import { LogoWrapper } from 'containers/landing/landing-page.styles';
import { DESKTOP } from 'containers/landing/breakpoints';
import Link from 'components/link';

const PageWrapper = styled.div`
  background-color: ${({ theme }) => theme.background};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const TextWrapper = styled.div`
  color: ${({ theme }) => theme.content};
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (min-width: ${DESKTOP}) {
    padding: 24px 34px;
    max-width: 1000px;
    margin: 0 auto;
  }
  @media (min-width: 1000px) {
    padding: 24px 64px;
  }
`;

const Header = styled.h2`
  ${fontL}
  margin-bottom: 24px;
`;

const Paragraph = styled.p`
  margin-bottom: 24px;
  ${fontM};

  a {
    color: ${({ theme }) => theme.content};
    ${fontM};
  }
`;

const YourData = (): JSX.Element => {
  return (
    <ThemeProvider theme={lightTheme}>
      <PageWrapper>
        <Link href="/">
          <LogoWrapper>
            <SVG
              icon="logo:playersLounge"
              type="dark"
              height="23px"
              width="122px"
            />
          </LogoWrapper>
        </Link>
        <TextWrapper>
          <Paragraph>
            Looking for information about what data we collect and how we handle
            it? Check out our{' '}
            <a
              href="https://playerslounge.co/privacy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
            .
          </Paragraph>
          <Header>Requesting that we remove your personal data?</Header>
          <Paragraph>
            If you choose to delete your account, your account and account
            balance will become inaccessible and your bet history will be
            deleted. Some account information will be maintained for legal and
            fraud prevention purposes.
          </Paragraph>
          <Paragraph>
            To proceed with account deletion, email{' '}
            <a href="mailto: help@playerslounge.com">help@playerslounge.com</a>{' '}
            {`with the subject line "Delete my account". Include in the body of
            the email the phone number or email address associated with your
            Players' Lounge account. Once we have confirmed your request, your
            account will be deleted within 30 days.`}
          </Paragraph>
        </TextWrapper>
        <Footer />
      </PageWrapper>
    </ThemeProvider>
  );
};

export default YourData;
